export enum TemplateTypes {
    OutboundFavorites = 'outboundFavorites',
}

export type TemplateItem<T> = {
    id?: string;
    type: TemplateTypes;
    createdBy: string;
    createdOn: string;
    modifiedBy?: string;
    modifiedOn?: string;
    data: T;
    userAccessList: string[];
};
